module.exports = __webpack_public_path__ + "media/svg/jp-4ecbd30a.svg";